import { Box, Flex, GridItem, SimpleGrid, VStack } from '@chakra-ui/react';
import React, { Fragment } from 'react';
import { TextBlock } from 'src/apps/invest/common/components/TextBlock';
import { SectionHeader } from '../common/SectionHeader';

type ThingsWeLikeProps = {
  items: {
    description: string;
    image: JSX.Element;
    title: string;
    highlight: string;
  }[];
};

export const ThingsWeLike: React.FC<ThingsWeLikeProps> = ({ items }) => {
  return (
    <VStack alignItems={'flex-start'}>
      <Box mb={['0px', '40px']}>
        <SectionHeader text="Things We Like" />
      </Box>
      <SimpleGrid columns={[1, 1, 1, 2]} templateColumns={['1fr', '1fr', '1fr', 'min-content 1fr']} gap="25px">
        {items.map((item, i) => (
          <Fragment key={`record-${i}`}>
            <GridItem>
              <Box marginTop="12px">{item.image}</Box>
            </GridItem>
            <GridItem>
              <Flex
                flexDirection={['column', 'column', 'column', 'row']}
                gap={['5px', '5px', '5px', '20px']}
                lineHeight={'1.2'}
                textAlign={'left'}
                justifyContent={'flex-start'}
                marginBottom={['10px', '10px', '10px', 0]}
                alignItems={'flex-start'}
                paddingBottom="5px">
                <TextBlock weight="bold" fontSize="20px">
                  {item.title}
                </TextBlock>
                <TextBlock
                  paddingLeft="5px"
                  paddingRight="5px"
                  weight="bold"
                  fontSize="20px"
                  background={'linear-gradient(transparent 50%, #D6E8FF 20%) no-repeat; position: relative;'}>
                  {item.highlight}
                </TextBlock>
              </Flex>
              <TextBlock>{item.description}</TextBlock>
            </GridItem>
          </Fragment>
        ))}
      </SimpleGrid>
    </VStack>
  );
};

export const HouseIcon = () => (
  <svg width="40" height="32" viewBox="0 0 40 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="31" cy="22.998" r="9" fill="#D6E8FF" />
    <path
      d="M17.3382 0.248438C17.7132 -0.0828125 18.282 -0.0828125 18.6632 0.248438L32.032 12.0484C31.6945 12.0172 31.3507 11.9984 31.0007 11.9984C30.3632 11.9984 29.7382 12.0547 29.132 12.1547L18.0007 2.32969L6.00072 12.9172V26.9984C6.00072 28.6547 7.34447 29.9984 9.00072 29.9984H13.0007V19.9984C13.0007 18.8922 13.8945 17.9984 15.0007 17.9984H21.0007C21.0632 17.9984 21.132 18.0047 21.1945 18.0047C20.8757 18.6359 20.6132 19.2984 20.4132 19.9984H15.0007V29.9984H16.0007H21.0007H22.5132C23.1382 30.7547 23.8695 31.4297 24.6757 31.9984H9.00072C6.23822 31.9984 4.00072 29.7609 4.00072 26.9984V14.6859L1.66322 16.7484C1.25072 17.1109 0.613217 17.0734 0.250717 16.6609C-0.111783 16.2484 -0.0742834 15.6109 0.338217 15.2484L17.3382 0.248438ZM31.0007 29.9984C32.8572 29.9984 34.6377 29.2609 35.9505 27.9482C37.2632 26.6354 38.0007 24.855 38.0007 22.9984C38.0007 21.1419 37.2632 19.3614 35.9505 18.0487C34.6377 16.7359 32.8572 15.9984 31.0007 15.9984C29.1442 15.9984 27.3637 16.7359 26.051 18.0487C24.7382 19.3614 24.0007 21.1419 24.0007 22.9984C24.0007 24.855 24.7382 26.6354 26.051 27.9482C27.3637 29.2609 29.1442 29.9984 31.0007 29.9984ZM31.0007 13.9984C33.3877 13.9984 35.6768 14.9467 37.3647 16.6345C39.0525 18.3223 40.0007 20.6115 40.0007 22.9984C40.0007 25.3854 39.0525 27.6746 37.3647 29.3624C35.6768 31.0502 33.3877 31.9984 31.0007 31.9984C28.6138 31.9984 26.3246 31.0502 24.6368 29.3624C22.9489 27.6746 22.0007 25.3854 22.0007 22.9984C22.0007 20.6115 22.9489 18.3223 24.6368 16.6345C26.3246 14.9467 28.6138 13.9984 31.0007 13.9984ZM35.207 20.2922C35.5945 20.6797 35.5945 21.3172 35.207 21.7047L30.707 26.2047C30.3195 26.5922 29.682 26.5922 29.2945 26.2047L26.7945 23.7047C26.407 23.3172 26.407 22.6797 26.7945 22.2922C27.182 21.9047 27.8195 21.9047 28.207 22.2922L30.0007 24.0859L33.7945 20.2922C34.182 19.9047 34.8195 19.9047 35.207 20.2922Z"
      fill="black"
    />
  </svg>
);

export const NewConstructionIcon = () => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_3746_18360)">
      <path
        d="M2.25755 8.79164C1.48765 8.42449 1.50133 7.32391 2.28011 6.97599L13.1007 2.14203C13.767 1.84433 14.5175 2.33768 14.5085 3.06748L14.385 13.0028C14.376 13.7326 13.6134 14.2071 12.9547 13.893L2.25755 8.79164Z"
        fill="#D6E8FF"
      />
      <path
        d="M2 7.99904L14 1.99904V13.999L2 7.99904ZM16 1.99904C16 1.30529 15.6438 0.661543 15.05 0.299043C14.4563 -0.0634573 13.725 -0.100957 13.1062 0.211543L1.10625 6.21154C0.425 6.54904 0 7.24279 0 7.99904C0 8.75529 0.425 9.44904 1.10625 9.78654L13.1062 15.7865C13.725 16.099 14.4625 16.0615 15.05 15.699C15.6375 15.3365 16 14.6928 16 13.999V8.99904H21.5C21.5 10.1053 22.3937 10.999 23.5 10.999H29C30.6562 10.999 32 9.65529 32 7.99904C32 6.34279 30.6562 4.99904 29 4.99904H23.5C22.3937 4.99904 21.5 5.89279 21.5 6.99904H16V1.99904ZM29 6.99904C29.55 6.99904 30 7.44904 30 7.99904C30 8.54904 29.55 8.99904 29 8.99904H23.5V6.99904H29ZM18 23.999H19H20H30V24.499V29.999H16V23.999H18ZM14 23.999V29.999H2V23.999H14ZM30 21.999H20V15.999H30V21.999ZM18 15.999V19.999V21.999H16H2C0.89375 21.999 0 22.8928 0 23.999V29.999C0 31.1053 0.89375 31.999 2 31.999H30C31.1063 31.999 32 31.1053 32 29.999V24.499V23.999V15.999C32 14.8928 31.1063 13.999 30 13.999H20C18.8937 13.999 18 14.8928 18 15.999Z"
        fill="black"
      />
    </g>
    <defs>
      <clipPath id="clip0_3746_18360">
        <rect width="32" height="32" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const StatAreaIcon = () => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M22 16C18.5 17.5 14 21.5 12 25C11.5 21 4.5 18 3 16C4.5 14 11.5 10 12 7C14 8.5 17.5 16.5 22 16Z"
      fill="#D6E8FF"
    />
    <path
      d="M27 2C27.55 2 28 2.45 28 3V6H31C31.55 6 32 6.45 32 7C32 7.55 31.55 8 31 8H28V11C28 11.55 27.55 12 27 12C26.45 12 26 11.55 26 11V8H23C22.45 8 22 7.55 22 7C22 6.45 22.45 6 23 6H26V3C26 2.45 26.45 2 27 2ZM27 20C27.55 20 28 20.45 28 21V24H31C31.55 24 32 24.45 32 25C32 25.55 31.55 26 31 26H28V29C28 29.55 27.55 30 27 30C26.45 30 26 29.55 26 29V26H23C22.45 26 22 25.55 22 25C22 24.45 22.45 24 23 24H26V21C26 20.45 26.45 20 27 20ZM8.55 13.525L3.3875 15.9125L8.55 18.2938C8.98125 18.4938 9.325 18.8375 9.525 19.2687L11.9062 24.4312L14.2875 19.2687C14.4875 18.8375 14.8313 18.4938 15.2625 18.2938L20.425 15.9125L15.2625 13.5312C14.8313 13.3313 14.4875 12.9875 14.2875 12.5562L11.9062 7.39375L9.525 12.5562C9.325 12.9875 8.98125 13.3313 8.55 13.5312V13.525ZM7.7125 20.1125L0.58125 16.8188C0.225 16.6562 0 16.3 0 15.9125C0 15.525 0.225 15.1688 0.58125 15.0063L7.7125 11.7125L11 4.58125C11.1625 4.225 11.5188 4 11.9062 4C12.2937 4 12.65 4.225 12.8125 4.58125L16.1063 11.7125L23.2375 15C23.5938 15.1625 23.8188 15.5188 23.8188 15.9062C23.8188 16.2937 23.5938 16.65 23.2375 16.8125L16.1125 20.1125L12.8188 27.2375C12.6562 27.5938 12.3 27.8188 11.9125 27.8188C11.525 27.8188 11.1688 27.5938 11.0063 27.2375L7.7125 20.1125Z"
      fill="black"
    />
  </svg>
);
